import React from 'react';
// import { Modal, ModalHeader } from 'reactstrap';
import { FormPrecodedText } from './FormPrecodedText';
import { DeletePrecodedText } from './DeletePrecodedText';
import { Dialog } from 'primereact/dialog';

export const ModalPrecodedText = (props) => {
    const { modal, toggle, loading, method, id_type_precoded_text, text, typePrecodedTexts, handleInputChange, validaciones, saveCreate, saveUpdate, saveDelete } = props;
    const dialogTitle =
            method === "create"
                ? "Creación de texto precodificado"
                : method === "update"
                    ? "Actualización de texto precodificado"
                    : "Eliminar texto precodificado";
    return (
          <Dialog
            header={dialogTitle}
            visible={modal}
            className="tiny-dialog"
            modal
            closable={true}
            onHide={toggle}
            dismissableMask={false}
            blockScroll
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold'
            }}
         
        >
            {method === "create" ? (
                <FormPrecodedText
                    button="Crear texto precodificado"
                    {...{
                        toggle,
                        id_type_precoded_text,
                        text,
                        typePrecodedTexts,
                        handleInputChange,
                        validaciones,
                        methodAction: saveCreate
                    }}
                />
            ) : method === "update" ? (
                <FormPrecodedText
                    button="Actualizar texto precodificado"
                    {...{
                        toggle,
                        loading,
                        id_type_precoded_text,
                        text,
                        typePrecodedTexts,
                        handleInputChange,
                        validaciones,
                        methodAction: saveUpdate
                    }}
                />
            ) : (
                <DeletePrecodedText {...{ toggle, loading, text, saveDelete }} />
            )}
        </Dialog>
    )
}
